export default __webpack_public_path__ + "static/media/hipa-logo.0abeaaac.svg";